import React from 'react'

import { MAIN_URL, LANDING_URL } from './urls'

export const urlify = (text) => {
  var urlRegex = /(https?:\/\/[^\s]+)/g
  let url
  let adaptedText = text.replace(urlRegex, function (url) {
    return React.createElement('<a href="' + url + '">' + url + '</a>')
  })

  return {
    text: adaptedText,
    url,
  }
}

/**
 * As we have kind of inconsistency  in returned URLs from backend. so a normalizer is required.
 * This function checks for these 3 unnormal urls and normalizes them:
 *
 * 1 - urls without base url (starting with /)
 * 2-  urls without base url (not starting with /)
 * 3 - urlls with two base urls
 *
 * @param {string} url - url address
 * @param {string} baseUrl - base url which is by default the API url
 *
 * @returns {string}
 */
export const getNormalizedUrl = (url = '', baseUrl = MAIN_URL) => {
  if (!url.startsWith('http')) {
    url = `${baseUrl}/${url.replace(/^\/+/, '')}`
  }

  const baseUrlPattern = new RegExp(`(${baseUrl})\\/\\1+`)

  return url.replace(baseUrlPattern, baseUrl)
}

export const getLandingUtmSourceLinkUrl = (location) =>
  `${LANDING_URL}/?utm_source=${location}&utm_campaign=referralPoweredBy&utm_medium=widget&ref=BkGc3gsq4&PBUI=true`

/**
 * checks if two urls are the same or not. the reason for using this method istead of just using === is for some symbols like / at the end of url
 *
 * @param {string} url1
 * @param {string} url2
 * @returns {boolean}
 */
export function areUrlsEqual(url1, url2) {
  try {
    const u1 = new URL(url1)
    const u2 = new URL(url2)

    return u1.origin === u2.origin && u1.pathname === u2.pathname && u1.search === u2.search
  } catch (error) {
    return false
  }
}

/**
 * this function checks if url matches with the pattern or not.
 * pattern functions is in this format: https://url/*
 * for example:
 * pattern: https://www.example.com/*
 * valid urls: https://www.example.com/1 or https://www.example.com/1/2/3
 *
 * pattern: https://www.example.com/2
 * only valid url: https://www.example.com/2
 *
 * @param {string} url - url to get tested
 * @param {string} pattern - url pattern
 * @returns {Boolean}
 */
export const matchUrlPattern = (url, pattern) => {
  // Escape special regex characters except for *
  let regexPattern = pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&')

  // Replace * with regex to match any character (except slashes)
  regexPattern = regexPattern.replace(/\*/g, '.*')

  // Allow an optional trailing slash
  regexPattern = regexPattern.replace(/\/?$/, '/?')

  // Create a new regex with start (^) and end ($) anchors
  const regex = new RegExp('^' + regexPattern + '$')

  // Test the URL against the pattern
  return regex.test(url)
}

export const getHostWebsiteUrl = () => window.PARENT_DOM_URL 
